<template>
	<AppLayout :title="trans('general.version.title')">
		<div class="grow flex flex-col items-center justify-center gap-6">
			<img class="size-[200px] rounded-2xl" :src="logo" :alt="`${version} Logo`">
			<p class="text-4xl font-bold text-pink-400 dark:text-pink-600">{{ version }}</p>
			<p class="text-xl">{{ serverTime }}</p>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import AppLayout from '@/Layouts/AppLayout.vue'

defineProps<{
	logo:string,
	version:string,
	serverTime:string,
}>()
</script>